import { Component, OnInit, Input, ContentChild, Renderer2, ElementRef, HostBinding } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { encapsulation } from '../../../components/encapsulation';
import { UBXButtonGroupComponent } from '../../button/button-group/button-group.component';
import { UBXModalService } from '../../../services';

@Component({
    selector: 'ubx-modal-box',
    templateUrl: './modal-box.component.html',
    host: { class: 'ubx-modal-box flx f-fd:c p:rl pe:a' },
    encapsulation,
    animations: [
        trigger('animate', [
            transition(':enter', [
                style({ opacity: 0, transform: 'scale(0.75)' }),
                animate('0.25s 0.25s ease', style({ opacity: 1, transform: 'scale(1)' }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('0.25s ease', style({ opacity: 0 }))
            ]),
        ]),
    ],
})
export class UBXModalBoxComponent implements OnInit {
    @Input() size: string;
    @Input() theme: string;
    @Input() heading: string;

    @ContentChild(UBXButtonGroupComponent, { static: true }) buttonGroup: UBXButtonGroupComponent;

    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private modalService: UBXModalService,
    ) { }

    @HostBinding('@animate')

    ngOnInit() {
        this.setSize(this.size);
        this.appendClass(this.buttonGroup.el, 'mg:ta');
    }

    setClass(type: string, value: string): string {
        return `${type}:${value}`;
    }

    closeModal() {
        this.modalService.close();
    }

    private setSize(size: string) {
        if (size) {
            const value = size.split(':');
            this.renderer.setStyle(this.el.nativeElement, 'max-width', `${value[0]}px`);
            this.renderer.setStyle(this.el.nativeElement, 'max-height', `${value[1]}px`);
        }
    }
    private appendClass(el: ElementRef, name: string) {
        this.renderer.addClass(el.nativeElement, name);
    }
}
